import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import ExhibitionsPage from './pages/ExhibitionsManagePage';
import ContactMessagesPage from './pages/ContactMessagesPage';

import AdminLayout from './components/AdminLayout';

const AdminRouter = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="exhibitions" element={<ExhibitionsPage />} />
        <Route path="contact-messages" element={<ContactMessagesPage />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminRouter;